const tips_old = [
    "Make social connection — especially face-to-face — a priority",
    " Make leisure and contemplation a priority",
    "Eat a brain-healthy diet to support strong mental health ",
    "Surround yourself with good people",
    "Break up the monotony",
    "Avoid alcohol and other drugs"
]
const tips = [
    "Spend time with nature. Go for a walk",
    "Connect and interact with supporting people",
    "Meditate and do breathing exercises",
    "practice your hobbies in your spare time",
    "Spend time reading good books",
    "Invest in Getting Good Sleep"
]


export default tips